import React from 'react';
import classNames from 'classnames';

import { Service } from '@nvs/gatsby-theme-leap-core/src/components/hoc/context/product/configuration-model';
import { CardData } from '@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card';
import { NovartisPatientSupportFtoSVG } from '../assets/images/novartisPatientSupportFto';
import { RichText } from '@nvs/gatsby-theme-leap-core/src/components/hoc/components';
import useTranslation from '@nvs/gatsby-theme-leap-core/src/hooks/useTranslation';

const CardLeft: React.FC<{
	data: CardData;
	service: Service;
	defaultClassName: string;
	titleClassName: string;
	printMode?: boolean;
}> = ({ service, titleClassName, printMode = false }) => {
	const { t } = useTranslation();

	return (
		<div
			className={classNames('basis-[40%] rounded-bl-2xl rounded-tl-2xl flex flex-col items-center gap-y-4 sm:gap-9 p-3 sm:p-4', {
				'bg-brand text-font-contrast': !printMode,
			})}>
			<div
				className={classNames('self-start text-font gap-y-5')}>
				<NovartisPatientSupportFtoSVG className={classNames('fill-font w-16 sm:w-28 h-4 sm:h-8', {
				'fill-font-contrast' : !printMode,
			})}/>
			</div>
			<div className='flex flex-col'>
				<div className={classNames(titleClassName)}>
					<RichText html={t(`services.${service.name}.card`)} />
				</div>
			</div>
		</div>
	);
};

export default CardLeft;
